<template>
  <v-card flat tile>
    <v-layout :column="$vuetify.breakpoint.smAndDown">
      <v-flex xs7 class="pa-0">
        <v-card flat tile color="white" class="pa-4">
          <h2 class="display-1 secondary--text">
            {{ listing.title }}
          </h2>
          <p
            v-if="listing.recurrencePattern"
            class="subtitle-1 primary--text font-weight-medium mb-2"
          >
            <v-icon small class="mr-1">repeat</v-icon>
            {{ listing.recurrencePattern }}
            <span v-if="listing.eventStart" class="caption">
              (Next: {{ formatShortDate(listing.eventStart) }})
            </span>
          </p>
          <p
            v-else-if="listing.event_on"
            class="subtitle-1 primary--text font-weight-medium mb-2"
          >
            <v-icon small class="mr-1">event</v-icon>
            {{ formatEventDate(listing.event_on) }}
          </p>
          <p class="subheading">
            {{ listing.description }}
          </p>
          <router-link
            v-for="(shield, key) in SHIELDS"
            :key="key"
            :to="{ name: 'About', hash: `#${key}` }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-img
                  v-if="
                    listing.shields && listing.shields.includes(shield.title)
                  "
                  :src="require(`../assets/${shield.imgsrc}`)"
                  class="shield-img d-inline-block"
                  v-on="on"
                />
              </template>
              <span>{{ shield.title }} (Click for more information)</span>
            </v-tooltip>
          </router-link>
        </v-card>
      </v-flex>
      <v-flex xs5 class="pa-0">
        <v-card flat tile color="grey lighten-3" class="pa-4">
          <h6 class="title secondary--text">Contact</h6>
          <p v-if="listing.address" class=".body-1 primary--text overflow-wrap">
            Address: {{ listing.address }}
          </p>
          <p v-if="listing.phone" class=".body-1 primary--text overflow-wrap">
            Tel: {{ listing.phone }}
          </p>
          <p
            v-if="listing.dsnphone"
            class=".body-1 primary--text overflow-wrap"
          >
            Military DSN Tel: {{ listing.dsnphone }}
          </p>
          <p v-if="listing.email" class=".body-1 primary--text overflow-wrap">
            Email: {{ listing.email }}
          </p>
          <a
            v-if="listing.website && !kioskMode"
            :href="redirectUrl"
            class=".body-1 primary--text overflow-wrap"
            target="_blank"
            rel="noopener noreferrer"
          >
            Website: {{ listing.website }}
          </a>
          <p
            v-else-if="listing.website"
            class=".body-1 primary--text overflow-wrap"
          >
            Website: {{ listing.website }}
          </p>
          <div v-if="listing.website && kioskMode" style="text-align: center">
            <div style="width: 200px; margin: auto">
              <qr-code :text="qrUrl" :size="200" />
            </div>
            Scan the QR code with your smart device's camera app for more
            information
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { SHIELDS } from "../constants";
import QrCode from "vue-qrcode-component";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    QrCode
  },
  props: {
    // TODO:
    // eslint-disable-next-line vue/require-default-prop
    listing: Object
  },
  computed: {
    ...mapState({ kioskMode: state => state.kioskMode }),
    ...mapGetters(["siteUrl"]),
    SHIELDS() {
      return SHIELDS;
    },
    redirectUrl() {
      return `${this.siteUrl}/api/go/${this.listing.id}`;
    },
    qrUrl() {
      return `${this.siteUrl}/api/scan/${this.listing.id}`;
    }
  },
  methods: {
    formatEventDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const dateOptions = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      const timeOptions = {
        hour: "numeric",
        minute: "2-digit"
      };
      const formattedDate = date.toLocaleDateString("en-US", dateOptions);
      const formattedTime = date.toLocaleTimeString("en-US", timeOptions);
      return `${formattedDate} at ${formattedTime}`;
    },
    formatShortDate(dateString) {
      if (!dateString) return "";

      let date;
      // For date-only strings (no "T"), parse as local date to avoid timezone shift
      if (!dateString.includes("T")) {
        const parts = dateString.split("-");
        date = new Date(parts[0], parts[1] - 1, parts[2]);
      } else {
        date = new Date(dateString);
      }

      const options = {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit"
      };
      return date.toLocaleDateString("en-US", options);
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

.shield-img {
  width: 20%;
  max-width: 80px;
}

.overflow-wrap {
  overflow-wrap: break-word;
}
</style>
